// extracted by mini-css-extract-plugin
export default {"root":"dFwShb","link":"jfBh1q","linkNewHeight":"BTjKG7","contents":"ewQCZR","text":"ZvdXh3","button":"xVWRM2"};